import { fetchAuthSession } from 'aws-amplify/auth';

export const getUserToken = async (): Promise<string> => {
  try {
    const session = await fetchAuthSession();
    const cognitoToken = session.tokens?.accessToken.toString() ?? '';
    return cognitoToken;
  } catch (error) {
    console.error('Error getting user token:', error);
    throw new Error('User is not authenticated');
  }
};

/** Cognito access token when signed in; null when anonymous (no throw). */
export const getUserTokenOptional = async (): Promise<string | null> => {
  try {
    const session = await fetchAuthSession();
    const cognitoToken = session.tokens?.accessToken.toString() ?? '';
    return cognitoToken || null;
  } catch {
    return null;
  }
};
